import { useFormContext } from 'react-hook-form';
import { FormSchema } from '@/app/register/schema';

type Props = {
  value: boolean;
  index: number;
};

export default function StayNow({ value, index }: Props) {
  const { setValue } = useFormContext<FormSchema>();

  const setStayNow = (value: boolean, index: number) => {
    setValue(`workplace.${index}.stayNow`, value, { shouldDirty: true });
    // NOTE: 「現在も所属」にチェックをした場合、retiredDateの値自体はリセットさせる必要があるため
    if (value)
      setValue(
        `workplace.${index}.retiredDate`,
        { year: '', month: '' },
        { shouldDirty: true }
      );
  };

  return (
    <label className="relative mt-[12px] inline-block cursor-pointer">
      <input
        type="checkbox"
        onChange={() => {
          setStayNow(!value, index);
        }}
        checked={value}
        className="hidden"
      />
      <span
        className={`absolute left-[5px] top-[2px] block h-[18px] w-[18px] rounded-[2px] ${
          value
            ? 'bg-primary-500 after:absolute after:left-[3px] after:top-[4px] after:h-[7px] after:w-[12px] after:rotate-[-45deg] after:border-b-[2px] after:border-l-[2px] after:border-solid after:border-white'
            : 'border-[2px] border-solid border-black opacity-50'
        }`}
      ></span>
      <p className="ml-[32px] text-[14px] text-[#231717]">現在も所属</p>
    </label>
  );
}
